function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var emitEvent = function(name, detail) {
    window.dispatchEvent(new CustomEvent(name, {
        bubbles: true,
        detail: detail
    }));
};
var Modal = /*#__PURE__*/ function() {
    "use strict";
    function Modal() {
        var _this = this;
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, Modal);
        this.options = {
            modalSelector: '[data-modal]',
            modalVideoSelector: '[data-modal-video]',
            modalCloseSelector: '[data-modal-close]',
            closeByOverlayClick: true,
            modalVideoId: 'modal_video',
            language: {
                loadingText: 'Loading...'
            },
            duration: 250
        };
        if ((typeof options === "undefined" ? "undefined" : _type_of(options)) === 'object') {
            this.options = _object_spread({}, this.options, options);
        }
        this.modals = [];
        // prepare for video
        if (document.querySelector(this.options.modalVideoSelector)) {
            document.body.insertAdjacentHTML('beforeend', '\n				<div class="modal modal_video" id="'.concat(this.options.modalVideoId, '">\n					<div class="modal__container">\n						<button class="modal__close" data-modal-close>\n							<svg class="icon icon_close" viewBox="0 0 40 40" style="width: 4rem; height: 4rem;">\n								<use xlink:href="#close"></use>\n							</svg>\n						</button>\n						<div class="modal__iframe"></div>\n					</div>\n				</div>\n			'));
        }
        document.addEventListener('click', function(e) {
            // open by button
            if (e.target.matches(_this.options.modalSelector) || e.target.closest(_this.options.modalSelector)) {
                e.preventDefault();
                var $el = e.target.matches(_this.options.modalSelector) ? e.target : e.target.closest(_this.options.modalSelector);
                _this.open($el.getAttribute('href').substring(1), $el);
            }
            // open video by button
            if (e.target.matches(_this.options.modalVideoSelector) || e.target.closest(_this.options.modalVideoSelector)) {
                e.preventDefault();
                var $el1 = e.target.matches(_this.options.modalVideoSelector) ? e.target : e.target.closest(_this.options.modalVideoSelector);
                _this.openVideo($el1.getAttribute('href'), $el1);
            }
            // close by button
            if (e.target.matches(_this.options.modalCloseSelector) || e.target.closest(_this.options.modalCloseSelector)) {
                e.preventDefault();
                _this.close(e.target.closest('.modal').getAttribute('id'));
            }
            // close by overlay click
            if (e.target.matches('.modal') && _this.options.closeByOverlayClick) {
                e.preventDefault();
                var id = e.target.getAttribute('id');
                if (id !== 'code' && id !== 'cancel') _this.close(id);
            }
        });
        // close by Esc
        document.addEventListener('keydown', function(e) {
            if (document.documentElement.classList.contains('-modal-locked') && e.keyCode === 27) {
                if (_this.modals.length) {
                    _this.close(_this.modals[_this.modals.length - 1]);
                }
            }
        });
    }
    _create_class(Modal, [
        {
            key: "open",
            value: function open(id) {
                var $trigger = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                var $modal = document.getElementById(id);
                if (!$modal) {
                    return;
                }
                emitEvent('modalBeforeOpen', {
                    id: id,
                    trigger: $trigger
                });
                this.modals.push(id);
                $modal.classList.add('modal_opened');
                emitEvent('modalOpen', {
                    id: id,
                    trigger: $trigger
                });
                setTimeout(function() {
                    $modal.classList.add('modal_visible');
                }, 10);
                window.lenis.stop();
                emitEvent('modalAfterOpen', {
                    id: id,
                    trigger: $trigger
                });
            }
        },
        {
            key: "openVideo",
            value: function openVideo(href) {
                var $trigger = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                emitEvent('modalBeforeOpen', {
                    id: this.options.modalVideoId,
                    trigger: $trigger
                });
                this.modals.push(this.options.modalVideoId);
                var $modal = document.getElementById(this.options.modalVideoId);
                if (href.indexOf('youtube') > -1 || href.indexOf('vimeo') > -1) {
                    var $iframe = document.createElement('iframe');
                    $iframe.setAttribute('allowfullscreen', 'allowfullscreen');
                    $iframe.setAttribute('frameborder', '0');
                    $iframe.setAttribute('allow', 'autoplay; fullscreen');
                    if (href.indexOf('youtube') > -1) {
                        var src = href.replace(/watch\?v=/g, 'embed/');
                        $iframe.setAttribute('src', "".concat(src, "?autoplay=1"));
                    }
                    if (href.indexOf('vimeo') > -1) {
                        var src1 = href.replace(/[^0-9]/g, '');
                        $iframe.setAttribute('src', "https://player.vimeo.com/video/".concat(src1, "?autoplay=1"));
                    }
                    $modal.querySelector('.modal__iframe').appendChild($iframe);
                } else {
                    var $video = document.createElement('video');
                    $video.src = href;
                    $video.controls = false;
                    var newDiv = document.createElement('div');
                    // Добавляем ему класс modal__iframe-play
                    newDiv.classList.add('modal__iframe-play');
                    // Создаем SVG элемент
                    var svgContent = '\n<svg class="icon icon_play" viewBox="0 0 40 40" style="width: 4rem; height: 4rem;">\n            	<use xlink:href="#play"></use>\n            </svg>\n			';
                    // Вставляем SVG внутрь нового div
                    newDiv.innerHTML = svgContent;
                    $modal.querySelector('.modal__iframe').appendChild($video);
                    $modal.querySelector('.modal__iframe').appendChild(newDiv);
                    var $videoPlay = document.querySelector('.modal__iframe-play');
                    newDiv === null || newDiv === void 0 ? void 0 : newDiv.addEventListener('click', function() {
                        newDiv.remove();
                        $video.controls = true;
                        $video.play();
                    });
                }
                $modal.classList.add('modal_opened');
                emitEvent('modalOpen', {
                    id: this.options.modalVideoId,
                    trigger: $trigger
                });
                setTimeout(function() {
                    $modal.classList.add('modal_visible');
                }, 10);
                window.lenis.stop();
                emitEvent('modalAfterOpen', {
                    id: this.options.modalVideoId,
                    trigger: $trigger
                });
            }
        },
        {
            key: "close",
            value: function close(id) {
                var _this = this;
                var $modal = document.getElementById(id);
                if (!$modal || this.modals.indexOf(id) < 0) {
                    return;
                }
                emitEvent('modalBeforeClose', {
                    id: id
                });
                this.modals = this.modals.filter(function(item) {
                    return item !== id;
                });
                $modal.classList.remove('modal_visible');
                emitEvent('modalClose', {
                    id: id
                });
                var handleClose = function() {
                    $modal.classList.remove('modal_opened');
                    var $modalIframe = $modal.querySelector('.modal__iframe iframe');
                    var $modalVideo = $modal.querySelector('.modal__iframe video');
                    if ($modalIframe) {
                        $modalIframe.remove();
                    }
                    if ($modalVideo) {
                        var _$modal_querySelector;
                        $modalVideo.remove();
                        (_$modal_querySelector = $modal.querySelector('.modal__iframe-play')) === null || _$modal_querySelector === void 0 ? void 0 : _$modal_querySelector.remove();
                    }
                    emitEvent('modalAfterClose', {
                        id: id
                    });
                    $modal.removeEventListener('transitionend', handleClose);
                    window.lenis.start();
                    if (!_this.modals.length) {
                        document.documentElement.classList.remove('-modal-locked');
                    }
                };
                $modal.addEventListener('transitionend', handleClose);
            }
        }
    ]);
    return Modal;
}();
export default Modal;
